const BUTTON_BOX_SIZE = {
  MAX: 'max',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  TINY: 'tiny',
  LARGE_FULL: 'largefull'
};
const BUTTON_DOUBLE_RATIO = {
  HALF: 'half',
  46: '46'
};
const BUTTON_VARIANT = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  /**
   * @deprecated use `<ButtonBox variant='tertiary' variantType='line' />`
   */
  BASIC: 'basic'
};
const BUTTON_CUSTOM_COLOR = 'custom';
const BUTTON_PRIMARY_COLOR = {
  GREEN: 'green',
  GREEN400: 'green400',
  BLUE: 'blue',
  RED: 'red',
  NEON_GREEN: 'neonGreen',
  DARK_GRAY400: 'darkGray400',
  DARK_GRAY500: 'darkGray500',
  GRADIENT_GREEN: 'gradientGreen',
  NPAY_GREEN: 'npayGreen',
  GRAY: 'gray'
};
const BUTTON_RAINBOW_COLOR = {
  DEEP_ORANGE: 'deepOrange',
  ORANGE: 'orange',
  YELLOW: 'yellow',
  OLIVE: 'olive',
  APPLE_GREEN: 'appleGreen',
  FOREST: 'forest',
  TEAL: 'teal',
  CYAN: 'cyan',
  LIGHT_BLUE: 'lightBlue',
  INDIGO: 'indigo',
  DEEP_PURPLE: 'deepPurple',
  PURPLE: 'purple',
  BROWN: 'brown',
  SADDLE_BROWN: 'saddleBrown'
};
const BUTTON_COLOR = {
  ...BUTTON_PRIMARY_COLOR,
  ...BUTTON_RAINBOW_COLOR,
  BUTTON_CUSTOM_COLOR
};
const BUTTON_TEXT_UNDERLINE_COLOR = {
  GREEN500: 'green500',
  GRAY600: 'gray600',
  GRAY700: 'gray700',
  GRAY800: 'gray800',
  GRAY900: 'gray900'
};
const BUTTON_VARIANT_TYPE = {
  FILL: 'fill',
  LINE: 'line'
};

export { BUTTON_BOX_SIZE, BUTTON_COLOR, BUTTON_CUSTOM_COLOR, BUTTON_DOUBLE_RATIO, BUTTON_PRIMARY_COLOR, BUTTON_RAINBOW_COLOR, BUTTON_TEXT_UNDERLINE_COLOR, BUTTON_VARIANT, BUTTON_VARIANT_TYPE };
